import {round} from "../utils/money";

export class Portion {
  constructor(amount, weight) {
    this._amount = amount;
    this._weight = weight;
  }

  get amount() {
    return this._amount;
  }

  set amount(amount) {
    this._amount = Number(amount);
  }

  set weight(weight) {
    this._weight = weight;
  }

  get weight() {
    return this._weight;
  }

  increment(amount = 1) {
    this._amount += amount;
  }

  add(portion) {
    if (!(portion instanceof Portion))
      throw new Error('portion has to be instance of Portion Class');

    if (!this.isEqual(portion))
      throw new Error('portion unit has to match');

    this.amount = round(this.amount + portion.amount, 2);
  }

  isEqual(portion) {
    return this.weight.isEqualUnit(portion.weight);
  }

  getFactor() {
    return this._amount * (this._weight.amount / 100);
  }

  toJSON() {
    return {
      amount: this.amount,
      weight: this.weight,
    };
  }
}
